import Component from "~/route-containers/partner/services.container";
import { servicesLoader } from "~/loaders/services.loader";
import { MetaFunction } from "@remix-run/node";
export { servicesLoader as loader };

export const meta: MetaFunction = () => {
  return [
    { name: "charset", content: "utf-8" },
    { title: "Servicios" },
    {
      name: "viewport",
      content: "width=device-width,initial-scale=1,maximum-scale=1",
    },
    { name: "og:title", content: "Servicios" },
  ];
};

export default Component;
